var map = {
	"./logo1.jpg": 3680,
	"./logo10.jpg": 1850,
	"./logo11.jpg": 855,
	"./logo12.jpg": 1928,
	"./logo13.jpg": 9189,
	"./logo14.jpg": 8302,
	"./logo15.jpg": 4763,
	"./logo16.jpg": 7068,
	"./logo2.jpg": 8639,
	"./logo3.jpg": 8642,
	"./logo4.jpg": 5201,
	"./logo5.jpg": 6676,
	"./logo6.jpg": 8483,
	"./logo7.jpg": 7430,
	"./logo8.jpg": 6661,
	"./logo9.jpg": 5752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7120;